/* eslint-disable @typescript-eslint/no-explicit-any */
import { getIdSports } from '../../../common/data/sports';
import {  getModel } from '../../../services/api.service';
import { ITeamProfileReturn } from '../interfaces/defy';

/**
 * Get defy by ID
 */
export const getTeamProfile = async (sport: string): Promise<ITeamProfileReturn> => {
    const sportId = getIdSports(sport);
    const urlModel = `users/profile/team/${sportId}`;
    const data = await getModel(urlModel);
    return data;
};
